import LeiaMais from './LeiaMais';
export default LeiaMais;